export interface StockPrice {
  stockTimestamp: Date;
  stockDate: Date;
  symbol: string;
  open: number;
  high: number;
  low: number;
  price: number;
  volume: number;
  latestTradingDay: string;
  previousClose: number;
  change: number;
  changePercent: number;
}
